import React, {useEffect, useState} from "react";
import {useContextElement} from "../../context/Context";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import QuantitySelect from "../components/QuantitySelect";
import SizePicker from "../product-details/SizePicker";
import AdminSpinner from "../components/AdminSpinner";

export default function Quickview() {
    const [quantity, setQuantity] = useState(1);
    const [selectedVariantGuid, setSelectedVariantGuid] = useState(null);
    const [sizeWarning, setSizeWarning] = useState(false);


    const {
        quickViewItem,
        addProductToCart,
        isAddedToCartProducts,
        cartProducts,
        updateQuantity,
        reloadCart,
        setQuickViewLoading,  // 🔴 eksikti
        quickViewLoading,     // 🔴 eksikti
    } = useContextElement();



    // Quickview içinde, state'lerin üstünde bir yerde:
    const selectedVariant =
        quickViewItem?.variants?.find(v => v.guid === selectedVariantGuid) || null;

    const maxStock = (() => {
        const n = Number(selectedVariant?.quantity);
        return Number.isFinite(n) ? n : 5; // quantity yoksa 5 sınırı kullan
    })();

    // quickViewItem geldiğinde stoklu bir varyantı otomatik seç
    useEffect(() => {
        if (!quickViewItem?.variants?.length) return;

        const sizePriority = ["M", "L", "S", "XL", "XS"];
        const pick =
            sizePriority
                .map(sz =>
                    quickViewItem.variants.find(
                        v => v.size === sz && v.isStock && Number(v.quantity) > 0
                    )
                )
                .find(Boolean) ||
            quickViewItem.variants.find(v => v.isStock && Number(v.quantity) > 0) ||
            quickViewItem.variants[0]; // hepsi 0 ise ilkini seç (buton yine engellenir)

        setSelectedVariantGuid(pick?.guid ?? null);
        setQuantity(1);
        setSizeWarning(false);
    }, [quickViewItem]);


// Varyant değiştiğinde quantity sınırı aşmasın:
    useEffect(() => {
        if (!selectedVariant) return;
        if (quantity > maxStock) {
            setQuantity(Math.max(1, maxStock));
        }
    }, [selectedVariantGuid, maxStock]); // selectedVariant değişimini bu şekilde yakalıyoruz


    useEffect(() => {
        if (!quickViewItem) return;

        let isCancelled = false;

        const images = document.querySelectorAll("#quickView img");

        if (images.length === 0) {
            setQuickViewLoading(false);
            return;
        }

        let loadedCount = 0;

        images.forEach((img) => {
            if (img.complete) {
                loadedCount++;
            } else {
                img.onload = () => {
                    loadedCount++;
                    if (loadedCount === images.length && !isCancelled) {
                        setQuickViewLoading(false);
                    }
                };
                img.onerror = () => {
                    loadedCount++;
                    if (loadedCount === images.length && !isCancelled) {
                        setQuickViewLoading(false);
                    }
                };
            }
        });

        if (loadedCount === images.length) {
            setQuickViewLoading(false);
        }

        return () => {
            isCancelled = true;
        };
    }, [quickViewItem]);


    // if (quickViewLoading || !quickViewItem) {
    //     return (
    //         <div className="modal fade modalCentered modal-quick-view" id="quickView">
    //             <div className="modal-dialog modal-dialog-centered">
    //                 <div className="modal-content d-flex justify-content-center align-items-center"
    //                      style={{minHeight: 300}}>
    //                     <span className="icon-close icon-close-popup" data-bs-dismiss="modal"/>
    //                     <div className="py-5"><AdminSpinner/></div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }


    // const currentQty = isAddedToCartProducts(quickViewItem.slug)
    //     ? cartProducts.find((item) => item.slug === quickViewItem.slug)?.quantity || 1
    //     : quantity;


    return (
        <div className="modal fade modalCentered modal-quick-view" id="quickView">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <span
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="modal"
                    />
                    {quickViewLoading || !quickViewItem ? (
                        <div className="modal-body text-center p-5">
                            <span className="loader"/>
                        </div>
                    ) : (
                        <>

                            <div className="tf-product-media-wrap">
                                <Swiper
                                    dir="ltr"
                                    className="swiper tf-single-slide"
                                    modules={[Navigation]}
                                    navigation={{
                                        prevEl: ".qvsnp1",
                                        nextEl: ".qvsnn1",
                                    }}
                                >
                                    {(quickViewItem.images?.[0]?.itemImages || []).map((img, index) => (
                                        <SwiperSlide key={index} className="swiper-slide">
                                            <div className="item">
                                                <img
                                                    className="lazyload"
                                                    alt={quickViewItem.name}
                                                    src={img}
                                                    width={513}
                                                    height={729}
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                    <div className="swiper-button-prev nav-swiper arrow-1 qvsnp1"/>
                                    <div className="swiper-button-next nav-swiper arrow-1 qvsnn1"/>
                                </Swiper>
                            </div>
                            <div className="tf-product-info-wrap">
                                <div className="tf-product-info-inner">
                                    <div className="tf-product-info-heading">
                                        <h6 className="product-info-name">{quickViewItem.name}</h6>
                                        <div className="product-info-price">
                                            <h6 className="price-new price-on-sale">
                                                £{Number(quickViewItem.price).toFixed(2)}
                                            </h6>
                                            {quickViewItem.oldPrice && (
                                                <h6 className="price-old">
                                                    ${Number(quickViewItem.oldPrice).toFixed(2)}
                                                </h6>
                                            )}
                                        </div>
                                        <p className="text">{quickViewItem.detail}</p>
                                    </div>

                                    <div className="tf-product-info-variant">
                                        <SizePicker
                                            selectedGuid={selectedVariantGuid}
                                            onSelect={setSelectedVariantGuid}
                                            variants={quickViewItem.variants}
                                        />
                                    </div>

                                    <div className="tf-product-total-quantity">
                                        {sizeWarning && (
                                            <div
                                                style={{
                                                    marginBottom: "10px",
                                                    color: "red",
                                                    fontSize: "14px",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Please select a size before adding to cart!
                                            </div>
                                        )}
                                        <div className="group-btn">
                                            <QuantitySelect
                                                quantity={
                                                    isAddedToCartProducts(quickViewItem.id)
                                                        ? cartProducts.filter(
                                                            (elm) => elm.id == quickViewItem.id
                                                        )[0].quantity
                                                        : quantity
                                                }
                                                setQuantity={(qty) => {
                                                    if (isAddedToCartProducts(quickViewItem.id)) {
                                                        updateQuantity(quickViewItem.id, qty);
                                                    } else {
                                                        setQuantity(qty);
                                                    }
                                                }}
                                                max={maxStock}     // 👈 stok limiti
                                                min={1}
                                            />
                                            {/*<a*/}
                                            {/*    href="#shoppingCart"*/}
                                            {/*    data-bs-toggle="offcanvas"*/}
                                            {/*    className="tf-btn hover-primary"*/}
                                            {/*    // onClick={() => addProductToCart(quickViewItem.slug, quantity)}*/}
                                            {/*    onClick={async () => {*/}
                                            {/*        if (!selectedVariantGuid) {*/}
                                            {/*            console.warn("⚠️ Hiçbir beden seçilmedi!");*/}
                                            {/*            return;*/}
                                            {/*        }*/}

                                            {/*        await addProductToCart(quickViewItem.slug, quantity, selectedVariantGuid);*/}
                                            {/*        await reloadCart();*/}

                                            {/*        const modalEl = document.getElementById("quickView");*/}
                                            {/*        document.activeElement?.blur(); // Şu an odakta olan elementi blur yap*/}
                                            {/*        const modalInstance = window.bootstrap?.Modal?.getInstance(modalEl);*/}
                                            {/*        if (modalInstance) {*/}
                                            {/*            modalInstance.hide();*/}
                                            {/*        } else {*/}
                                            {/*            console.warn("🛑 Modal instance bulunamadı.");*/}
                                            {/*        }*/}
                                            {/*    }}*/}

                                            {/*>*/}
                                            {/*    {isAddedToCartProducts(quickViewItem.slug)*/}
                                            {/*        ? "Already Added"*/}
                                            {/*        : "Add to cart -"}*/}
                                            {/*</a>*/}


                                            <a
                                                href="#shoppingCart"
                                                {...(selectedVariantGuid ? {'data-bs-toggle': 'offcanvas'} : {})}
                                                onClick={async () => {
                                                    if (!selectedVariantGuid) {

                                                        setSizeWarning(true);
                                                        return;
                                                    }

                                                    setSizeWarning(false);
                                                    await addProductToCart(quickViewItem.slug, quantity, selectedVariantGuid);
                                                    await reloadCart();
                                                }}
                                                className="tf-btn hover-primary btn-add-to-cart"
                                            >
                                                {isAddedToCartProducts(quickViewItem.slug)
                                                    ? "Already Added"
                                                    : "Add to cart -"}
                                            </a>


                                        </div>
                                    </div>

                                    <Link
                                        to={`/product-detail/${quickViewItem.slug}`}
                                        className="view-details link mt-4 d-inline-block"
                                    >
                                        View full details <i className="icon icon-arrow-right"/>
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
